"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingRoundRadioButtonGroupView = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var SettingRoundRadioButtonView_1 = require("./SettingRoundRadioButtonView");
var index_1 = require("../../../index");
var index_2 = require("../../../index");
function SettingRoundRadioButtonGroupView(props) {
    var data = props.data, onClick = props.onClick;
    var _a = tslib_1.__read(react_1.useState(""), 2), language = _a[0], Setlanguage = _a[1];
    var handleLanguage = function (newlanguage) {
        Setlanguage(newlanguage);
        onClick(newlanguage);
    };
    return (react_1.default.createElement(index_2.ThemeWrap, null, data.map(function (item, index) { return (react_1.default.createElement("div", { key: index },
        language !== item.language && (react_1.default.createElement(SettingRoundRadioButtonView_1.SettingRoundRadioButtonViewDefault, { language: item.language, country: item.country, icon: item.icon, onClick: handleLanguage })),
        language === item.language && (react_1.default.createElement(SettingRoundRadioButtonView_1.SettingRoundRadioButtonViewChoosed, { language: item.language, country: item.country, icon: item.icon, onClick: handleLanguage })),
        index !== data.length && (react_1.default.createElement("div", null,
            react_1.default.createElement(index_1.SettingDivider, null))))); })));
}
exports.SettingRoundRadioButtonGroupView = SettingRoundRadioButtonGroupView;
//# sourceMappingURL=index.js.map